import React, { useState } from 'react';
import { FaCaretDown } from "react-icons/fa";
import { Link } from 'react-router-dom';
import './Sidebar.css';
import { icons } from 'lucide-react';

function Sidebar({ logo }) {
    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleDropdown = (index) => {
        // Toggle the dropdown for the selected item
        setOpenDropdown(openDropdown === index ? null : index);
    };

    const menuItems = [
        { name: 'Dashboard', link: '/', icon: '📊' },
        { name: 'Lead Master', link: '/leads', icon: '👥' },
        { name: 'Reports', link: '/reports', icon: '📑' },
        { name: 'Internal', link: '/internal', icon: '🏢' },
        { name: 'LeadSquare', link: '/leadsquare', icon: '🏢' },
        { name: 'Upgrade', link: '/upgrad', icon: '🏢' },

        {
            name: 'Websites',
            link: '/departments',
            icon: '🌐',
            dropdownIcon: <FaCaretDown />,
            submenu: [
                { name: 'Collegeall.com', link: '/website/collegeall' },
                { name: '123admissions.com', link: '/website/admissions' },
                { name: 'iop.liba.edu', link: '/website/iop' },
                { name: 'Manipal', link: '/website/manipal' }
            ]
        },
        { name: 'Register Student', link: '/jobregister', icon: '📝' },
        {
            name: 'Departments',
            link: '/departments',
            icon: '🏢',
            dropdownIcon: <FaCaretDown />,
            submenu: [
                { name: 'HR', link: '/departments/hr-department' },
                { name: 'Finance', link: '/departments/finance-department' },
                { name: 'IT', link: '/departments/it-department' },
                { name: 'Sales', link: '/departments/sales-department' }
            ]
        },
        { name: 'Employee', link: '/employee', icon: '👤' },
        { name: 'Register Student', link: '/register-student', icon: '📝' },
        { name: 'Accounts', link: '/accounts', icon: '💰' },
        { name: 'Assets', link: '/assets', icon: '💼' },
        { name: 'Logout', link: '/logout', icon: '🚪' }
    ];

    const menuItems2 = [
        { name: 'Dashboard', link: '/', icon: '📊' },

        { name: 'Logout', link: '/logout', icon: '🚪' }
    ];
    const menuItems4 = [
        { name: 'Liba Student', link: '/', icon: '🎓' },
        { name: 'Leadsense Job', link: '/leadsense-job', icon: '🧑‍💼' },
        { name: 'Added Student', link: '/student/added', icon: '➕' },
        { name: 'Users Manage', link: '/usermanage', icon: '👥' },
        { name: 'Logout', link: '/logout', icon: '🚪' }
    ];
    const menuItems5 = [
        { name: 'Dashboard', link: '/', icon: '📊' },      // Dashboard icon
        { name: 'Info', link: '/info', icon: 'ℹ️' },      // Info icon
        { name: 'Consular', link: '/consular', icon: '🛂' }, // Passport/consular icon
        { name: 'Logout', link: '/logout', icon: '🚪' }   // Logout/exit icon
    ];

    const menuItems6 = [
        { name: 'Dashboard', link: '/', icon: '📊' },
        { name: 'LeadSquare', link: '/leadsquare', icon: '🏢' },
        { name: 'Upgrade', link: '/upgrad', icon: '🏢' },
        { name: 'Logout', link: '/logout', icon: '🚪' }
    ]


    const type = atob(sessionStorage.getItem('type'));

  return (
        <aside className="sidebar">
            <div className="sidebar-logo">
                <img src={logo} alt="Logo" className="sidebar-logo-img" />
            </div>
            <nav className="sidebar-nav">
                <ul>
                    {(type == 2
                        ? menuItems2
                        : type == 4
                            ? menuItems4
                            : type == 5
                                ? menuItems5
                                : type == 6 ?
                                    menuItems6 :
                                    menuItems).map(
                                        (item, index) => (
                                            <li key={index} className="sidebar-item">
                                                {!item.submenu ? (
                                                    <Link to={item.link} className="sidebar-link">
                                                        {item.icon && <span className="sidebar-icon">{item.icon}</span>}
                                                        <span className="sidebar-text">{item.name}</span>
                                                    </Link>
                                                ) : (
                                                    <>
                                                        <div
                                                            className="sidebar-link"
                                                            onClick={() => toggleDropdown(index)}
                                                            role="button"
                                                            aria-expanded={openDropdown === index ? "true" : "false"}
                                                            aria-controls={`submenu-${index}`}
                                                        >
                                                            {item.icon && <span className="sidebar-icon">{item.icon}</span>}
                                                            <span className="sidebar-text">{item.name}</span>
                                                            {item.dropdownIcon && (
                                                                <span className="sidebar-dropdown-icon" style={{ fontSize: "20px" }}>
                                                                    {item.dropdownIcon}
                                                                </span>
                                                            )}
        </div>
                                                        {openDropdown === index && (
                                                            <ul id={`submenu-${index}`} className="innerul">
                                                                {item.submenu.map((subItem, subIndex) => (
                                                                    <li key={subIndex}>
                                                                        <Link to={subItem.link}>{subItem.name}</Link>
                                                                    </li>
            ))}
                                                            </ul>
                                                        )}
                                                    </>
                                                )}
                                            </li>
                                        )
                                    )}
                </ul>

            </nav>
        </aside>
    );
}

export default Sidebar;
